import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Box, makeStyles } from '@material-ui/core';
import { C_ICON } from '../assets';
import { ProcessStateEnum } from '../types';
import {
  ClientColorCommentMap,
  ClientProcessStateToDescriptionMap,
  ProcessStateToTitleMap,
  purchaseOrderStatusToKorean,
  ProgressStoppedStatus
} from '../constant';
import { CapaPurchaseOrderStatus } from '@generated/graphql';

interface ProgressInfoHeaderProps {
  processStatus?: CapaPurchaseOrderStatus;
  isExtended?: boolean;
}

const ProgressInfoHeader: React.FunctionComponent<ProgressInfoHeaderProps> = ({
  processStatus,
  isExtended = false
}) => {
  const { topContainer, header } = useStyles();

  if (!processStatus) return null;
  const isShipping = processStatus === CapaPurchaseOrderStatus.Shipping;
  const isProgressStoppedStatus = ProgressStoppedStatus.includes(processStatus);
  const isPayoutDatePostponed = isShipping && isExtended;
  const stateToKorea = isPayoutDatePostponed
    ? '구매확정일연기'
    : purchaseOrderStatusToKorean[processStatus] ??
      ProcessStateEnum.계좌이체대기;

  return (
    <div className={topContainer}>
      <div className={header}>
        <div className={'header-title'}>
          <Box
            width={4}
            height={4}
            borderRadius={50}
            bgcolor={
              isProgressStoppedStatus ? colorSet.errorBase : colorSet.primary500
            }
          />
          <CustomizedTypography variant="body1" fontWeight="500">
            {ProcessStateToTitleMap[stateToKorea]}
          </CustomizedTypography>
        </div>

        <div className="header-icon">
          <img className="icon-img" src={C_ICON} alt="C_ICON-icon" />
          <CustomizedTypography variant="caption">
            캐파결제
          </CustomizedTypography>
        </div>
      </div>

      <CustomizedTypography
        variant="body2"
        fontWeight="500"
        color={isProgressStoppedStatus ? 'error' : 'primary'}
        gutterBottoms={2}
      >
        {ClientColorCommentMap[stateToKorea]}
      </CustomizedTypography>
      <CustomizedTypography variant={isShipping ? 'subtitle2' : 'body2'}>
        {ClientProcessStateToDescriptionMap[stateToKorea]}
      </CustomizedTypography>
    </div>
  );
};

export default ProgressInfoHeader;

const useStyles = makeStyles((theme) => ({
  topContainer: {
    '& p, h6': {
      wordBreak: 'break-all'
    }
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
    gap: 16,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse'
    },
    '& .header-title': {
      display: 'flex',
      alignItems: 'center',
      gap: 5
    },
    '& .header-icon': {
      backgroundColor: colorSet.gray200,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 97,
      height: 24,
      borderRadius: 100,
      padding: `3px 8px`,
      '& img': {
        width: 11,
        height: 12,
        marginRight: 4
      }
    }
  }
}));
